<template>

  <v-container fluid class="main-navigation-sysadmin">

    <div class="banner-sys-admin mt-1 mb-5">
      System Admin
    </div>

    <!-- Home page -->
    <router-link :to="{ name: 'home' }">
      <v-btn plain class="primary-nav-element" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-home</v-icon> Home
      </v-btn>
    </router-link>

    <!-- Track Order -->
    <router-link :to="{ name: 'track-order' }">
      <v-btn plain class="primary-nav-element mt-3" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-target</v-icon> Track Order
      </v-btn>
    </router-link>

    <!-- Shipper Accounts -->
    <v-expansion-panels flat accordion class="mt-4" v-model="manageShipperNavSetting">
      <v-expansion-panel>
        <v-expansion-panel-header>Shippers</v-expansion-panel-header>
        <v-expansion-panel-content>
          <router-link v-for="navItem in manageShipperNav" :key="navItem.page" :to="{ name: navItem.page }">
            <v-btn plain class="secondary-nav-element mt-2" @click="emitClickEvent">
              <v-icon small class="mr-2" v-if="navItem.icon">{{ navItem.icon }}</v-icon>
              {{ navItem.label }}
            </v-btn>
          </router-link>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Receiver Accounts -->
    <v-expansion-panels flat accordion class="mt-2" v-model="manageReceiverNavSetting">
      <v-expansion-panel>
        <v-expansion-panel-header>Receivers</v-expansion-panel-header>
        <v-expansion-panel-content>
          <router-link v-for="navItem in manageReceiverNav" :key="navItem.page" :to="{ name: navItem.page }">
            <v-btn plain class="secondary-nav-element mt-2" @click="emitClickEvent">
              <v-icon small class="mr-2" v-if="navItem.icon">{{ navItem.icon }}</v-icon>
              {{ navItem.label }}
            </v-btn>
          </router-link>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Org profile -->
    <router-link :to="{ name: 'org-profile' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-shield-account</v-icon> Org Profile
      </v-btn>
    </router-link>

    <!-- Org members -->
    <router-link :to="{ name: 'user-list' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-account-multiple</v-icon> Org Members
      </v-btn>
    </router-link>

    <!-- User settings -->
    <router-link :to="{ name: 'user-settings-profile' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-cog</v-icon> User Settings
      </v-btn>
    </router-link>

    <!-- Logout -->
    <v-btn plain class="primary-nav-element mt-5" @click="$root.logout">
      <v-icon small class="mr-2">mdi-logout</v-icon> Logout
    </v-btn>

  </v-container>

</template>

<script>
export default {
  name: 'MainNavigationSysAdminUi',

  data () {
    return {
      manageShipperNavSetting: 0,
      manageReceiverNavSetting: 0
    }
  },

  computed: {
    // Manage shipper account pages
    manageShipperNav () {
      return [
        { label: 'Shipper Orgs', page: 'shipper-org-list', icon: 'mdi-account-circle-outline' },
        { label: 'Shipper Locations', page: 'shipper-list', icon: 'mdi-truck' }
      ]
    },
    // Manage receiver account pages
    manageReceiverNav () {
      return [
        { label: 'Receiver Orgs', page: 'receiver-org-list', icon: 'mdi-account-circle-outline' },
        { label: 'Receiver Locations', page: 'receiver-list', icon: 'mdi-store' }
      ]
    }
  },

  methods: {
    emitClickEvent () {
      this.$emit('navClicked')
    }
  }
}
</script>

<style>
  .main-navigation-sysadmin .banner-sys-admin {
    color: #F9A825;
    border-top: 1px solid #F9A825;
    border-bottom: 1px solid #F9A825;
    font-size: 0.9rem;
    font-weight: 500;
    text-align: center;
    letter-spacing: 2.6px;
    /* padding: 4px 0; */
    text-transform: uppercase !important;
  }

  .main-navigation-sysadmin .primary-nav-element {
    padding-left: 8px !important;
  }

  .main-navigation-sysadmin .theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: #0e0e0e;
  }

  .main-navigation-sysadmin .v-expansion-panel-header {
    padding-left: 8px !important;
    padding-right: 36px !important;
    color: #727272;
    font-size: 0.8rem;
    font-weight: 500;
    letter-spacing: 1.6px;
    text-transform: uppercase !important;
  }

  .main-navigation-sysadmin .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: unset;
  }

  .main-navigation-sysadmin .v-expansion-panel-content__wrap {
    padding-left: 0px;
  }
</style>
